// extracted by mini-css-extract-plugin
export default {"notification":"aK9bw","icon":"YzoPt","text":"rKCIK","close":"tqg5b","success":"Za2nF","error":"klnp3"};